module.exports = __webpack_public_path__ + "img/logovue.82b9c7a5.png";